import { ROUTES } from './routes';

/**
 * Configuración del menú de navegación
 * Define los elementos que aparecerán en el header
 */

export const NAVIGATION_ITEMS = [
    {
        id: 'about',
        label: 'Nosotros',
        path: ROUTES.ABOUT,
    },
    {
        id: 'programs',
        label: 'Propuesta Educativa',
        path: ROUTES.PROGRAMS,
    },
    {
        id: 'workshops',
        label: 'Talleres',
        path: ROUTES.WORKSHOPS,
    },
    {
        id: 'admissions',
        label: 'Admisión 2026',
        path: ROUTES.ADMISSIONS,
    },
    {
        id: 'news',
        label: 'Noticias',
        path: ROUTES.NEWS,
    },
    {
        id: 'salas',
        label: 'Salas',
        path: ROUTES.SALAS,
    },
    {
        id: 'contact',
        label: 'Contacto',
        path: ROUTES.CONTACT,
    }
];
